import React, { useEffect, useState } from "react";
import ToastMessage from "../../../../common/ToastMessage";
import CustomDataGrid from '../../../../common/CustomDataGrid';
import useAssetActionTypes from "../../../../store/ReactQueries/assets/assetActionTypes/useAssetActionTypes";
import useAddAssetActionType from "../../../../store/ReactQueries/assets/assetActionTypes/useAddAssetActionType";
import useUpdateAssetActionType from "../../../../store/ReactQueries/assets/assetActionTypes/useUpdateAssetActionType";
import useDeleteAssetActionType from "../../../../store/ReactQueries/assets/assetActionTypes/useDeleteAssetActionType";
import { GridColDef } from "@mui/x-data-grid";
import { PAGESIZE } from "../../../../utils/constants";
import { formatDate } from "../../../../common/GlobalFunctions";
import { FieldErrors } from "../../../../domain/helpers/Errors";
import { validateSchema } from "../../../../common/ValidateSchema";
import { useLanguageStore } from "../../../../store/useLanguageStore";
import { AssetActionTypeInterface } from "../../../../models/AssetModel/AssetAction/AssetActionType";
import { assetActiontypeSchema } from "../../../../domain/ValidationSchemas/Asset/assetActionType";

export const AssetActionTypes = () => {

    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(PAGESIZE);
    const [errors, setErrors] = useState<FieldErrors>({});
    const [form, setForm] = useState<AssetActionTypeInterface>({
        id: "",
        title: "",
    });
    const [modal, setModal] = useState<{
        add: boolean;
        edit: boolean;
        view: boolean;
    }>({
        add: false,
        edit: false,
        view: false,
    });

    const { language } = useLanguageStore();
    let { data: assetCategory, error } = useAssetActionTypes(page, pageSize);

    const addAssetCategory = useAddAssetActionType(page, pageSize);
    const updateAssetCategory = useUpdateAssetActionType(page, pageSize);
    const deleteAssetCategory = useDeleteAssetActionType(page, pageSize);

    useEffect(() => {
        if (error) ToastMessage.Failed(`Error: ${error.message}`);
    }, [error]);


    const columns: GridColDef[] = [
        {
            field: "id",
            headerName: "Id",
            type: "string",
            editable: false,
            width: 200,
        },
        {
            field: "title",
            headerName: "Title",
            type: "string",
            editable: false,
            width: 250,
        },
        {
            field: "createdDate",
            headerName: "CreatedDate",
            type: "dateTime",
            editable: false,
            width: 150,
            valueFormatter: formatDate,
        },
        {
            field: "updatedDate",
            headerName: "UpdatedDate",
            type: "dateTime",
            editable: false,
            width: 150,
            valueFormatter: formatDate,
        },
    ];

    const addItems = () => {
        setForm({ ...form, title: "", id: "" });
        setModal({ ...modal, add: true });
        setErrors({});
    };

    const handleSave = async () => {
        const isValid = validateSchema(assetActiontypeSchema, { title: form.title });

        setErrors(isValid.errors);
        if (!isValid.result) return;

        const upForm: AssetActionTypeInterface = {
            id: form.id,
            title: form.title,
        };

        if (upForm.id === "") {
            const { id, ...formData } = upForm;
            addAssetCategory.mutate(formData, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => ToastMessage.Failed(error.message),
            });
        } else {
            updateAssetCategory.mutate(upForm, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => ToastMessage.Failed(error.message),
            });
        }

        setModal({ ...modal, add: false, edit: false, view: false });
    };

    const handleDelete = async (id: string) => {
        if (await ToastMessage.Confirm(language["ToastDeleteItem"])) {
            deleteAssetCategory.mutate(id, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => ToastMessage.Failed(error.message),
            });
        }
    };

    return (
        <CustomDataGrid
            name={language["AssetActionTypes"]}
            rows={assetCategory || []}
            form={form}
            page={page}
            modal={modal}
            errors={errors}
            columns={columns}
            pageSize={pageSize}
            setForm={setForm}
            setPage={setPage}
            addItems={addItems}
            setModal={setModal}
            setErrors={setErrors}
            handleSave={handleSave}
            setPageSize={setPageSize}
            handleDelete={handleDelete}
            hideColumns={['id']}
            showColumnModal={["title"]}
        />
    );
};
export default AssetActionTypes;
